export default __webpack_public_path__ + "static/media/sumod-react-developer.85de6984.pdf";